import { useSelector } from "react-redux";
import { selectAuth } from "../stores/authSlice";
import React, { ReactNode, useEffect } from "react";
import VerifyingPage from "@/components/Base/VerifyingPage";
import socket from "@/utils/socket";

interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const isAuthenticated = useSelector(selectAuth);

    useEffect(() => {
        socket.connect();
        return () => {
            socket.disconnect();
        };
    }, []);

    useEffect(() => {
        if (!isAuthenticated) {
            window.location.href = import.meta.env.VITE_LOGIN_URL || "/login";
        }
    }, [isAuthenticated]);

    if (!isAuthenticated) {
        return <VerifyingPage />;
    }

    return children;
};

export default ProtectedRoute;
